import NavigationCard from "../../Components/NavigationCard";
import Container from "@mui/material/Container";
import HighQualityIcon from "@mui/icons-material/HighQuality";

export const FormList = () => {
	return (
		<Container
			maxWidth="md"
			sx={{
				display: "flex",
				flex: "1 1 100%",
				justifyContent: "space-evenly",
				flexWrap: "wrap",
				marginTop: "2rem",
			}}
		>
			<NavigationCard
				link="/WebForm/QualityMonitoring"
				title="Quality Monitoring"
				img={
					<HighQualityIcon
						sx={{
							fontSize: 300,
						}}
					/>
				}
			/>
		</Container>
	);
};
